module.exports = __webpack_public_path__ + "img/img-character-600-x-270.3b9b55e6.png";